import type { WorkspaceRole } from "../shared/auth";
import { pathWithLocale, type Locale } from "./i18n";

export function canUseGovernance(role: WorkspaceRole | undefined): boolean {
  return role !== undefined && role !== "MEMBER";
}

export function defaultAuthenticatedPath(role: WorkspaceRole | undefined, locale: Locale): string {
  return pathWithLocale(role === "MEMBER" ? "/work" : "/app", locale);
}
